import { render, staticRenderFns } from "./TheTicket.vue?vue&type=template&id=31894f93&scoped=true&"
import script from "./TheTicket.vue?vue&type=script&lang=ts&"
export * from "./TheTicket.vue?vue&type=script&lang=ts&"
import style0 from "./TheTicket.vue?vue&type=style&index=0&id=31894f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31894f93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31894f93')) {
      api.createRecord('31894f93', component.options)
    } else {
      api.reload('31894f93', component.options)
    }
    module.hot.accept("./TheTicket.vue?vue&type=template&id=31894f93&scoped=true&", function () {
      api.rerender('31894f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheTicket.vue"
export default component.exports